export interface IDeleteEntityPayloadBaseModel {
  deleteRelation?: boolean;
}

export const DELETE_ENTITY_WITH_RELATION_PAYLOAD: IDeleteEntityPayloadBaseModel =
  {
    deleteRelation: true,
  };
